import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
gsap.registerPlugin(Flip);
class contentView {
  init() {
    this.section = document.querySelector(".viewport");
    this.content = document.querySelector(".stage");
    this.popupEl = document.querySelector(".popup");
    this.videoEl = document.getElementById("popupVideo");
    this.videoListContainer = document.querySelector(".video-list-container");
    this.closeBtn = document.querySelector(".popup__close");

    this.caseStudyPopup = document.getElementById("caseStudyPopup");
    this.caseStudyImageWrapper = this.caseStudyPopup?.querySelector(
      ".case-study-image-wrapper",
    );

    this.prevBtn = this.caseStudyPopup?.querySelector(".prev-btn");
    this.nextBtn = this.caseStudyPopup?.querySelector(".next-btn");
    this.casestudycloseBtn = this.caseStudyPopup?.querySelector(
      ".case-study-close-container",
    );

    this.casenav = document.querySelector(".case-study-nav");

    this.caseStudyImages = [];
    this.currentIndex = 0;
    this.isAnimating = false;

    // this.renderclosepopup();

    this.addCaseStudyListeners();

    this.rendersectionisclick = false;

    this.backisclick = false;
  }

  renderclosepopup(handler) {
    this.closeBtn.addEventListener("click", () => {
      this.hidePopup();
      handler();
    });
  }
  renderSection(section) {
    if (this.rendersectionisclick) return;
    this.rendersectionisclick = true;
    if (!section) return;
    // const many = section.cards.length > 6;
    let many = false;
    if (section.id === "upstream") {
      many = true;
    }
    const totalPages = section.cards.length;
    const html = `
     <section class="content" data-id="${section.id}" data-name="${section.id}">
            <div class="left">
              <div class="left__top-arrow" id="left__backBtn">
                <img src="images/content-arrow.png" alt="" />
              </div>
              <h2 class="left__title content-title-text-shadow">
                ${section.title || ""}
              </h2>
              <div class="left__desc">
                ${section.desc || ""}
            
              </div>                                                     
                  <div class="left__bottom-controls">
                    <div class="left__circle-arrow" id="left__slidePrev">
                      <img src="images/content-arrow.png" alt="" />
                    </div>
                    <div class="left__circle-arrow right_arrow" id="left__slideNext">
                      <img src="images/content-arrow.png" alt="" />
                    </div>
                  </div>
              </div>
            <div class="right ${many ? "" : "large"}"" id="rightsection">
              <div class="right__slide-counter ${many ? "" : "active"}">
                <div class="right__counter-num" id="counterCurrent">01</div>
                <div class="right__counter-line">
                  <div
                    class="right__counter-highlight"
                    id="counterHighlight"
                  ></div>
                </div>
                <div class="right__counter-num" id="counterTotal">${String(
                  totalPages,
                ).padStart(2, "0")}</div>
              </div>
            <div class="right__track-viewport ${many ? "" : "large"}">
              ${section.cards
                .map((card) => {
                  const tagHTML = Array.isArray(card.tag)
                    ? card.tag
                        ?.map(
                          (tag, i) => `
                          <div 
                            class="right__tag-title" 
                            data-card-id="${card.id}" 
                            data-name="${section.id}-${card.title}-${tag.title}${["Case Study", "Use Case", "View Gallery"].includes(tag.title) ? "" : "-video"}"
                            data-index="${i}">
                            ${tag.title}
                          </div>`,
                        )
                        .join("")
                    : card.tag && typeof card.tag === "object"
                      ? `<div 
                      class="right__tag-title" 
                      data-card-id="${card.id}"
                      data-name="${section.id}-${card.title}-${card.tag.title}${["Case Study", "Use Case", "View Gallery"].includes(card.tag.title) ? "" : "-video"}"
                      
                      data-index="0">
                      ${card.tag.title || ""}
                    </div>`
                      : "";

                  return `
                  <article class="right__card box ${
                    many ? "" : "large"
                  }" data-id="${card.id}" data-flip-id="${card.flipid}"  data-name="${section.id}-${card.title + "-" + (card.vidthumbnail === "yes" ? "video" : "image")}">
                    <div class="right__image ${many ? "" : "large"}">
                      <img src="${
                        card.image?.thumbnail || card.image
                      }" alt="" />
                      <div class="thumbnail playbtn-shadow ${
                        card.vidthumbnail === "yes" ? "active" : ""
                      } ${many ? "" : "large"}">
                        <img src="images/play.png" alt="" class="thumbnailimg" />
                    </div>
                    </div>
                    <div class="right__title content-title-text-card-shadow ${
                      many ? "" : "large"
                    } ${card?.smallfont === "yes" ? "small" : ""}" >
                      ${card.title}
                    </div>
                    <div class="right__desc ${many ? "" : "large"}">
                      ${card.desc || ""}
                    </div>
                    <div class="right__tag ${many ? "" : "large"}">
                      ${tagHTML}
                    </div>
                  </article>`;
                })
                .join("")}
            </div>
            </div>
        </section>`;
    this.content.innerHTML = html;

    this.show(section);

    this.initHighlight(".right__track-viewport", "#counterHighlight");
  }

  show(section) {
    // document.querySelector(".viewport").classList.add("active");
    if (section.id === "upstream") {
      this.animateToContent("upstream");
    } else {
      // this.animateToLarge(id);
      this.animateToContent("upstream");
    }
  }

  animateToContent(id) {
    const cards = document.querySelectorAll(".energy__card");
    const category = document.querySelector("#energy");
    const viewport = document.querySelector(".viewport");
    viewport.classList.add("active");
    // Capture the current layout
    const state = Flip.getState(cards);

    // Prepare viewport (hidden initially)
    gsap.set(viewport, { display: "flex", opacity: 0 });

    // Wait for new cards to be rendered
    setTimeout(() => {
      const newCards = document.querySelectorAll(".right__card");
      if (!newCards.length) return;

      const tl = gsap.timeline();

      // Faster fade out of category
      tl.to(
        category,
        {
          opacity: 0,
          duration: 0.6,
          ease: "power1.inOut",
        },
        0,
      );

      // Slight delay before viewport fade in (so they don’t blend too much)
      tl.to(
        viewport,
        {
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
        },
        0.3,
      );

      // Flip starts when viewport begins appearing
      tl.add(() => {
        Flip.from(state, {
          duration: 1.2,
          ease: "power3.inOut",
          scale: true,
          stagger: 0.05,
          targets: newCards,
          onComplete: () => {
            this.backisclick = false;
          },
        });
      }, 0.3);
    }, 400); // short delay for render
  }

  animateToCategory() {
    const newCards = document.querySelectorAll(".right__card");
    const category = document.querySelector("#energy");
    const viewport = document.querySelector(".viewport");
    viewport.classList.remove("active");
    // Capture the current layout of content cards
    const state = Flip.getState(newCards);

    // Prepare category section
    gsap.set(category, { display: "flex", opacity: 0 });

    // Timeline for coordinated crossfade + Flip
    const tl = gsap.timeline();

    // Fade out content quickly
    tl.to(
      viewport,
      {
        opacity: 0,
        duration: 0.5, // faster fade-out (previously 1.2)
        ease: "power2.inOut",
      },
      0,
    );

    // Fade in category slightly later, overlapping Flip
    tl.to(
      category,
      {
        opacity: 1,
        duration: 1,
        ease: "power2.out",
      },
      0.3,
    ); // start after a brief delay

    // Run Flip once crossfade begins
    tl.add(() => {
      const categoryCards = document.querySelectorAll(".energy__card");
      Flip.from(state, {
        duration: 1.2,
        ease: "power3.inOut",
        scale: true,
        stagger: 0.05,
        targets: categoryCards,
        clearProps: "all",
        onComplete: () => {
          this.rendersectionisclick = false;
        },
      });
    }, 0.3);
  }

  hide() {
    // document.querySelector(".viewport").classList.remove("active");
    this.animateToCategory();
  }

  renderbackclick(handler) {
    document.addEventListener("click", (e) => {
      if (e.target && e.target.id === "left__backBtn") {
        if (this.backisclick) return;
        this.backisclick = true;
        handler();
      }
    });
  }

  initHighlight(viewportSelector, highlightSelector) {
    const viewport = document.querySelector(viewportSelector);
    const highlight = document.querySelector(highlightSelector);
    if (!viewport || !highlight) return;

    const sectionEl = viewport.closest(".content");
    const sectionTitle =
      sectionEl
        ?.querySelector(".left__title")
        ?.textContent.trim()
        .toLowerCase() || "";

    const isUpstream = sectionTitle.includes("upstream");
    const scrollStep = viewport.offsetWidth / 2; // default half width

    const updateHighlight = () => {
      const visibleWidth = viewport.offsetWidth;
      const totalWidth = viewport.scrollWidth;
      const scrolled = viewport.scrollLeft;

      // ratio of visible area + scrolled portion
      const visibleRatio = Math.min((scrolled + visibleWidth) / totalWidth, 1);
      const percent = visibleRatio * 100;
      highlight.style.width = `${percent}%`;
    };

    // Initialize immediately (1 frame after DOM is painted)
    requestAnimationFrame(updateHighlight);

    // Update on scroll
    viewport.addEventListener("scroll", () =>
      requestAnimationFrame(updateHighlight),
    );

    // Optional: If your “Next” or “Prev” buttons move cards programmatically,
    // also update after they finish scrolling:
    const next = document.getElementById("left__slideNext");
    const prev = document.getElementById("left__slidePrev");
    let moved = false;
    // Apply translateX only for Upstream section
    if (isUpstream) {
      const cards = viewport.querySelectorAll(".right__card");
      const cardWidth = cards[0]?.offsetWidth || 0;
      const gap = parseFloat(getComputedStyle(cards[0]).marginRight || 0);
      const moveDistance = cardWidth + gap; // move by exactly one card width
      let currentTranslate = 0;
      if (next) {
        next.addEventListener("click", () => {
          if (moved) return;
          moved = true;
          const maxTranslate = -(10 * moveDistance - viewport.offsetWidth); //10 is hardcoded

          currentTranslate -= moveDistance;
          if (currentTranslate < maxTranslate) currentTranslate = maxTranslate;

          viewport.style.transform = `translateX(${currentTranslate}px)`;
          viewport.style.transition = "transform 0.5s ease";
        });
      }

      if (prev) {
        prev.addEventListener("click", () => {
          moved = false;
          currentTranslate += moveDistance;
          if (currentTranslate > 0) currentTranslate = 0;

          viewport.style.transform = `translateX(${currentTranslate}px)`;
          viewport.style.transition = "transform 0.5s ease";
        });
      }
    } else {
      if (next) {
        next.addEventListener("click", () => {
          viewport.scrollBy({ left: scrollStep, behavior: "smooth" });
          requestAnimationFrame(() => setTimeout(updateHighlight, 400));
        });
      }

      if (prev) {
        prev.addEventListener("click", () => {
          viewport.scrollBy({ left: -scrollStep, behavior: "smooth" });
          requestAnimationFrame(() => setTimeout(updateHighlight, 400));
        });
      }
    }
  }

  handleCardClick(handler) {
    document.body.addEventListener("click", (e) => {
      const card = e.target.closest(".right__card");
      if (!card) return;
      handler(card.dataset.id);
    });
  }

  handleTagClick(handler) {
    document.body.addEventListener("click", (e) => {
      const tag = e.target.closest(".right__tag-title");
      if (!tag) return;
      handler(tag.dataset.cardId, tag.dataset.index);
    });
  }

  renderCardPopup(cardData) {
    if (!cardData) return;

    // if (!cardData.type) return;

    if (cardData.type === "singlevideo" && cardData.id !== "m1") {
      this.videoListContainer.classList.remove("active");
      this.videoEl.src = cardData.image?.video || "";
      this.showPopup();
      return;
    }
  }

  renderTagPopup(cardData, tagIndex) {
    try {
      if (
        cardData.type === "singlevideo" &&
        cardData.tag &&
        ["Case Study", "Use Case", "Gallery"].includes(cardData.tag.title) &&
        cardData.specialtag === "no"
      ) {
        // Case Study popup
        this.hidePopup();
        this.openCaseStudyPopup(cardData.tag.images);
        return;
      }

      if (cardData.type === "singlevideo" && cardData.specialtag === "yes") {
        this.videoListContainer.classList.remove("active");
        this.videoEl.src = cardData.image?.video || "";
        this.showPopup();
        return;
      }

      // --- CASE 1 ---
      if (!cardData.type) {
        // No video popup for empty type
        if (
          cardData.tag &&
          ["Case Study", "Use Case", "View Gallery"].includes(
            cardData.tag.title,
          )
        ) {
          this.openCaseStudyPopup(cardData.tag.images);
        }
        return;
      }
      if (!cardData || !cardData.tag || !cardData.tag[tagIndex]) return;
      const tag = cardData.tag[tagIndex];

      // ✅ Case 3: singlevideo with multiple tag objects
      if (cardData.type === "singlevideo") {
        this.videoListContainer.classList.remove("active");
        const videoSrc = tag.videos?.[0]?.src;
        if (!videoSrc) return;
        this.videoEl.src = videoSrc;
        this.showPopup();
      }

      // ✅ Case 4: multivideo with multiple videos per tag
      else if (cardData.type === "multivideo") {
        this.videoListContainer.classList.add("active");

        // Build list of video buttons
        this.videoListContainer.innerHTML = tag.videos
          .map(
            (v, i) => `
          <div class="video-list" data-src="${v.src}" data-name="enterprise-${cardData.title}-${tag.title}-${v.title}-video">
          <button class="video-tab ${i === 0 ? "active" : ""}" >
            ${v.title || "Untitled"}
          </button>
                      <div class="video-tab-play playbtn-shadow">
                <img src="images/play.png" alt=""  />
              </div>
          </div>

        `,
          )
          .join("");

        // set first video
        this.videoEl.src = tag.videos[0]?.src || "";
        this.showPopup();

        // Handle switching videos
        this.videoListContainer.addEventListener("click", (e) => {
          const btn = e.target.closest(".video-list");
          if (!btn) return;
          this.videoListContainer
            .querySelectorAll(".video-tab")
            .forEach((b) => b.classList.remove("active"));

          btn.querySelector(".video-tab").classList.add("active");
          btn.classList.add("active");
          this.videoEl.src = btn.dataset.src;
          this.showPopup();
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  // --- CASE STUDY POPUP LOGIC BELOW ---
  addCaseStudyListeners() {
    if (!this.caseStudyPopup) return;

    this.prevBtn?.addEventListener("click", () => this.showPrevImage());
    this.nextBtn?.addEventListener("click", () => this.showNextImage());
    this.casestudycloseBtn?.addEventListener("click", () =>
      this.closeCaseStudyPopup(),
    );
  }

  openCaseStudyPopup(images) {
    if (!images?.length) return;
    if (images.length === 1) {
      this.casenav.classList.remove("active");
    } else {
      this.casenav.classList.add("active");
    }

    this.caseStudyImages = images;
    this.currentIndex = 0;
    this.renderCaseStudyImage(this.caseStudyImages[this.currentIndex]);
    this.caseStudyPopup.style.display = "flex";
    this.animaterightsection();
  }

  renderCaseStudyImage(src) {
    const newImg = document.createElement("img");
    newImg.src = src;
    newImg.classList.add("active");
    newImg.style.left = "100%";
    this.caseStudyImageWrapper.appendChild(newImg);

    // Slide in animation
    requestAnimationFrame(() => {
      newImg.style.left = "0";
      newImg.style.opacity = "1";
    });

    // Remove previous image
    const oldImg = this.caseStudyImageWrapper.querySelector(
      "img:not(:last-child)",
    );
    if (oldImg) {
      oldImg.classList.add("slide-out-left");
      setTimeout(() => oldImg.remove(), 600);
    }
  }

  showNextImage() {
    if (this.isAnimating) return;
    if (this.currentIndex >= this.caseStudyImages.length - 1) return;
    this.isAnimating = true;
    this.currentIndex = (this.currentIndex + 1) % this.caseStudyImages.length;
    this.renderCaseStudyImage(this.caseStudyImages[this.currentIndex]);
    setTimeout(() => (this.isAnimating = false), 600);
  }

  showPrevImage() {
    if (this.isAnimating) return;
    if (this.currentIndex <= 0) return;
    this.isAnimating = true;
    this.currentIndex =
      (this.currentIndex - 1 + this.caseStudyImages.length) %
      this.caseStudyImages.length;

    const newImg = document.createElement("img");
    newImg.src = this.caseStudyImages[this.currentIndex];
    newImg.classList.add("active");
    newImg.style.left = "-100%";
    this.caseStudyImageWrapper.appendChild(newImg);

    requestAnimationFrame(() => {
      newImg.style.left = "0";
      newImg.style.opacity = "1";
    });

    const oldImg = this.caseStudyImageWrapper.querySelector(
      "img:not(:last-child)",
    );
    if (oldImg) {
      oldImg.classList.add("slide-out-right");
      setTimeout(() => oldImg.remove(), 600);
    }

    setTimeout(() => (this.isAnimating = false), 600);
  }

  closeCaseStudyPopup() {
    this.resetanimaterightsection();
    this.caseStudyPopup.style.display = "none";
    this.caseStudyImageWrapper.innerHTML = "";
  }

  showPopup() {
    this.animaterightsection();
    this.initVideoControls();
    this.popupEl.classList.add("active");
    this.videoEl.play().catch((err) => {
      if (err.name !== "AbortError") console.error(err);
    });
  }

  hidePopup() {
    this.resetanimaterightsection();
    this.popupEl.classList.remove("active");
    this.videoEl.pause();
    this.videoEl.currentTime = 0;
    this.detachVideoListeners();
  }

  hidecasestudyPopup() {
    this.caseStudyPopup.classList.remove("active");
  }

  initVideoControls() {
    // Re-select fresh video and controls each time popup opens
    this.videoEl = document.getElementById("popupVideo");
    this.timeline = document.getElementById("timeline");
    this.playPauseBtn = document.querySelector(".playPause");
    this.muteBtn = document.querySelector(".muteunmute");
    this.timeDisplay = document.querySelector(".videotime");

    // 🚫 Before attaching again, remove previous listeners
    this.detachVideoListeners();

    // ✅ Then add them once
    this.bindVideoEvents();
  }
  detachVideoListeners() {
    if (!this.videoEl) return;

    this.playPauseBtn?.removeEventListener("click", this._onPlayPause);
    this.muteBtn?.removeEventListener("click", this._onMuteToggle);
    this.timeline?.removeEventListener("input", this._onSeek);
    this.videoEl?.removeEventListener("timeupdate", this._onTimeUpdate);
    this.videoEl?.removeEventListener("play", this._onPlayPauseIcon);
    this.videoEl?.removeEventListener("pause", this._onPlayPauseIcon);
    this.videoEl?.removeEventListener("ended", this._onVideoEnded);
  }

  bindVideoEvents() {
    if (!this.videoEl) return;

    // 🔹 Store handler references so we can remove them later
    this._onPlayPause = async () => {
      try {
        if (this.videoEl.paused) await this.videoEl.play();
        else this.videoEl.pause();
        this.updatePlayIcon();
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
      }
    };

    this._onMuteToggle = () => {
      this.videoEl.muted = !this.videoEl.muted;
      this.updateMuteIcon();
    };

    this._onSeek = () => {
      this.videoEl.currentTime = this.timeline.value;
    };

    this._onTimeUpdate = () => {
      if (!this.timeline) return;
      this.timeline.max = this.videoEl.duration || 0;
      this.timeline.value = this.videoEl.currentTime;
      this.updateTimeDisplay();
    };

    this._onPlayPauseIcon = () => this.updatePlayIcon();
    this._onVideoEnded = () => this.updatePlayIcon(true);

    // ✅ Add them once
    this.playPauseBtn.addEventListener("click", this._onPlayPause);
    this.muteBtn.addEventListener("click", this._onMuteToggle);
    this.timeline.addEventListener("input", this._onSeek);
    this.videoEl.addEventListener("timeupdate", this._onTimeUpdate);
    this.videoEl.addEventListener("play", this._onPlayPauseIcon);
    this.videoEl.addEventListener("pause", this._onPlayPauseIcon);
    this.videoEl.addEventListener("ended", this._onVideoEnded);
  }

  updatePlayIcon(forcePlay = false) {
    const playIcon = this.playPauseBtn.querySelector(".play");
    const pauseIcon = this.playPauseBtn.querySelector(".pause");

    if (forcePlay || this.videoEl.paused) {
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
    } else {
      playIcon.style.display = "none";
      pauseIcon.style.display = "block";
    }
  }

  updateMuteIcon() {
    const muteIcon = this.muteBtn.querySelector(".mute");
    const unmuteIcon = this.muteBtn.querySelector(".unmute");

    if (this.videoEl.muted) {
      muteIcon.style.display = "block";
      unmuteIcon.style.display = "none";
    } else {
      muteIcon.style.display = "none";
      unmuteIcon.style.display = "block";
    }
  }

  updateTimeDisplay() {
    if (!this.timeDisplay || !this.videoEl.duration) return;
    const current = this.formatTime(this.videoEl.currentTime);
    const total = this.formatTime(this.videoEl.duration);
    this.timeDisplay.textContent = `${current} / ${total}`;
  }

  formatTime(seconds) {
    if (isNaN(seconds)) return "0:00";
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${m}:${s}`;
  }

  animaterightsection() {
    this.rightSection = document.getElementById("rightsection");
    gsap.to(this.rightSection, {
      y: 100, // move 100px down
      opacity: 0.7,
      duration: 0.6,
      ease: "power2.out",
    });

    // Add blur to the background
    this.section.classList.add("blur-bg");
  }

  resetanimaterightsection() {
    this.rightSection = document.getElementById("rightsection");
    gsap.to(this.rightSection, {
      y: 0,
      opacity: 1,
      duration: 0.5,
      ease: "power2.inOut",
    });
    this.section.classList.remove("blur-bg");
  }
}

export default new contentView();
